<template>
  <div
    id="presentation"
    class="shop-section col-xs-12"
    v-bind:class="{ active: isActive }"
    @click="$emit('activeSection', 'presentation')"
  >
    <div class="header">
      <i class="fas fa-images section-icon" />

      <h5 class="section-title dark-blue-color">
        Shop Profile image
        <br />
        <small>Store's presentation settings</small>
      </h5>
    </div>
    <b-col class="option-content">
      <b-form id="presentation-form" @submit="saveDetails" v-if="shop">
        <b-row>
          <b-col sm="12" md="6">
            <b-form-group
              label="Logo"
              description="Set's the logo for your venue used on order receipts"
            >
              <a
                v-if="shopInfo.images.logo"
                :href="shopInfo.images.logo"
                class="preview-link"
                target="_blank"
                >Preview</a
              >
              <b-input-group>
                <b-form-input
                  v-model="shopInfo.images.logo"
                  placeholder="Enter here a url to your choice's logo"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    v-b-modal.image-editor-modal
                    @click="imageUploadType = 'shop-logo'"
                  >
                    Upload
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group
              label="Hero"
              description="Set's the hero background image for your store"
            >
              <a
                v-if="shopInfo.images.hero"
                :href="shopInfo.images.hero"
                target="_blank"
                class="preview-link"
                >Preview</a
              >
              <b-input-group>
                <b-form-input
                  v-model="shopInfo.images.hero"
                  placeholder="Enter here a url to your choice's hero image"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    v-b-modal.image-editor-modal
                    @click="imageUploadType = 'shop-hero'"
                  >
                    Upload
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="12">
            <b-button
              variant="primary"
              type="submit"
              class="float-right mb-1"
              :disabled="loading"
              pill
            >
              <b-spinner v-if="loading" />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
    <imageEditor
      :image-info="{
        type: imageUploadType,
        image: shopInfo.images.hero,
      }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageEditor from "../imageEditor";

export default {
  name: "shop-presentation",
  props: ["isActive"],
  components: {
    ImageEditor,
  },
  data: () => ({
    shopInfo: { images: {} },
    imageUploadType: "shop-hero",
  }),
  computed: {
    ...mapGetters("shop", ["shop", "loading"]),
  },
  methods: {
    saveDetails(e) {
      e.preventDefault();
      let shopInfo = {
        images: { ...this.shopInfo.images },
      };
      this.$emit("saveChanges", shopInfo);
    },
  },
  mounted() {
    this.shopInfo = {
      images: {},
      ...JSON.parse(JSON.stringify(this.shop)),
    };
  },
  watch: {
    shop(newVal) {
      if (newVal) {
        this.shopInfo = {
          images: {},
          ...JSON.parse(JSON.stringify(newVal)),
        };
      }
    },
  },
};
</script>

<style scoped>
.preview-link {
  position: absolute;
  top: 0;
  right: 15px;
}
</style>
